import { render, staticRenderFns } from "./BillQuery.vue?vue&type=template&id=2c3a398a&scoped=true"
import script from "./BillQuery.vue?vue&type=script&lang=js"
export * from "./BillQuery.vue?vue&type=script&lang=js"
import style0 from "./BillQuery.vue?vue&type=style&index=0&id=2c3a398a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a398a",
  null
  
)

export default component.exports